import { cn } from '../util';

interface HeadingProps {
  children: React.ReactNode;
  size: 'xsm' | 'sm' | 'm' | 'l';
  className?: string;
}

export const Heading = ({ size, className, children }: HeadingProps) => {
  return (
    <h2
      className={cn(
        'my-0 py-0 font-bold',
        size === 'xsm' && 'text-sm',
        size === 'sm' && 'text-base',
        size === 'm' && 'text-2xl',
        size === 'l' && 'text-3xl',
        className
      )}
    >
      {children}
    </h2>
  );
};
